var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.18 57.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.39,57.15h-.43c-1.04,0-1.95-.73-2.19-1.74-.12-.5-3-12.21-15-14.68-.25-.05-.5-.1-.76-.14-.68,2.36-1.72,4.74-3.32,6.74-3.25,4.07-9.29,8.58-14.07,8.92-2.43.18-3.97-.76-4.82-1.57-.79-.75-2.4-2.94-.25-7.08,2.59-4.97,9.91-11.18,18.85-11.67.48-3.43.25-6.27.25-6.32-.1-1.24.81-2.33,2.05-2.43,1.24-.06,2.32.81,2.43,2.05.02.24.26,3.21-.23,6.95.25.04.51.09.77.14,7.17,1.48,11.69,5.59,14.46,9.53v-18.72c0-.42.11-.81.31-1.14L28.59,5.34,6.73,25.98c.2.34.31.73.31,1.14v27.78c0,1.24-1.01,2.25-2.25,2.25s-2.25-1.01-2.25-2.25v-25.53h-.3c-.92,0-1.75-.56-2.09-1.42s-.12-1.83.55-2.46L27.05.61c.87-.82,2.22-.82,3.09,0l26.34,24.88c.67.63.89,1.61.55,2.46s-1.17,1.42-2.09,1.42h-.3v25.53c0,1.24-1.01,2.25-2.25,2.25ZM14.99,51.55s.39.3,1.32.21c2.93-.2,7.91-3.52,10.87-7.24.93-1.16,1.62-2.53,2.13-3.96-4.89.7-9.12,3.5-11.67,6.24-2.34,2.51-2.76,4.35-2.66,4.74h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.cde0864af6ec8b2e9ef1a58c955d33dd.svg";
export { ForwardRef as ReactComponent };